import { HawaiiViews } from './HawaiiViews';


export const MapViews = Object.keys(HawaiiViews).map(view => {
    const zones = HawaiiViews[view];
    return Object.keys(zones).map(zone => ({ ...zones[zone] }));
});
